let model;
let queue = Promise.resolve();
const cache = new Map();
export function cropPosition(width, height, focal, ratio = 16 / 9) {
  const visibleWidth = Math.min(width, height * ratio);
  const visibleHeight = Math.min(height, width / ratio);
  const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
  const x = width === visibleWidth ? 50 : clamp((focal.x * width - visibleWidth / 2) / (width - visibleWidth) * 100, 0, 100);
  const y = height === visibleHeight ? 50 : clamp((focal.y * height - visibleHeight * 0.35) / (height - visibleHeight) * 100, 0, 100);
  return `${x}% ${y}%`;
}
function loadModel() {
  if (!model) model = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/vendor/face-api.min.js';
    script.onload = async () => {
      try { await window.faceapi.nets.tinyFaceDetector.loadFromUri('/models'); resolve(window.faceapi); } catch (error) { reject(error); }
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return model;
}
export function detectFocus(src) {
  if (cache.has(src)) return cache.get(src);
  const result = queue.catch(() => {}).then(async () => {
    const api = await loadModel();
    const response = await fetch(`/api/focus-image?url=${encodeURIComponent(src)}`, { signal: AbortSignal.timeout(10000) });
    if (!response.ok) return null;
    const blobUrl = URL.createObjectURL(await response.blob());
    try {
      const img = await new Promise((resolve, reject) => { const image = new Image(); image.onload = () => resolve(image); image.onerror = reject; image.src = blobUrl; });
      const canvas = document.createElement('canvas');
      const scale = Math.min(1, 640 / Math.max(img.width, img.height));
      canvas.width = Math.round(img.width * scale); canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      const faces = await api.detectAllFaces(canvas, new api.TinyFaceDetectorOptions({inputSize:416, scoreThreshold:0.35}));
      if (!faces.length) return null;
      const left = Math.min(...faces.map(face => face.box.x));
      const top = Math.min(...faces.map(face => face.box.y));
      const right = Math.max(...faces.map(face => face.box.x + face.box.width));
      const bottom = Math.max(...faces.map(face => face.box.y + face.box.height));
      return { x: (left + right) / 2 / canvas.width, y: (top + bottom) / 2 / canvas.height, faceWidth:(right-left)/canvas.width, faceHeight:(bottom-top)/canvas.height };
    } finally { URL.revokeObjectURL(blobUrl); }
  });
  queue = result;
  cache.set(src, result);
  return result;
}
